import { Icon } from "@/ds";

import { ConflitoGanttSecao } from "../../../conflito-gantt-secao";
import { ConflitoJustificativa } from "../../../conflito-justificativa";
import { GANTT_SECTION_LABEL } from "../../resolver-conflito-local.constants";
import { RevisaoGantt } from "../revisao-gantt";
import styles from "./revisao-step.module.scss";
import type { RevisaoStepViewModel } from "./types-revisao-step";

export function RevisaoStepView({
  localNome,
  substitutoNome,
  obraRotulo,
  legenda,
  gantt,
  alocacao,
  periodo,
  today,
  disabled,
  justificativa,
}: RevisaoStepViewModel) {
  return (
    <>
      <p className={styles.resumo} data-testid="resolver-conflito-revisao-resumo">
        O local <strong>{localNome}</strong> será substituído por <strong>{substitutoNome}</strong>{" "}
        na <strong>{obraRotulo}</strong>.
      </p>

      <ConflitoGanttSecao titulo={GANTT_SECTION_LABEL} legenda={legenda}>
        <RevisaoGantt data={gantt} alocacao={alocacao} periodo={periodo} today={today} />
      </ConflitoGanttSecao>

      <span className={styles.nota} data-testid="resolver-conflito-nota">
        <Icon name="exclamation-triangle" size={10.5} />
        Apenas o local da {obraRotulo} será substituído.
      </span>

      <ConflitoJustificativa
        id="resolver-conflito-justificativa"
        value={justificativa.value}
        onChange={justificativa.alterar}
        error={justificativa.error}
        disabled={disabled}
        divided
        testId="resolver-conflito-justificativa"
        maxLength={justificativa.maxLength}
      />
    </>
  );
}
